export const staticAdvertData = {
  siteBanner: {
    id: 900,
    name: 'Edge of Play',
    slot: 'siteBanner',
    link: 'mailto:commercial@edgeofplay.com',
    image: require('../../images/adverts/eop-1366x100.jpg'),
    active: true,
    width: 1366,
    height: 100,
    minWidth: 781,
    maxWidth: undefined
  },
  siteBannerMobile: {
    id: 901,
    name: 'Edge of Play',
    slot: 'siteBanner',
    link: 'mailto:commercial@edgeofplay.com',
    image: require('../../images/adverts/eop-360x80.jpg'),
    active: true,
    width: 360,
    height: 80,
    minWidth: undefined,
    maxWidth: 780
  },
  homepageBanner: {
    id: 902,
    name: 'Edge of Play',
    slot: 'homepageBanner',
    link: 'mailto:commercial@edgeofplay.com',
    image: require('../../images/adverts/eop-1366x300.jpg'),
    active: true,
    width: 1366,
    height: 300,
    minWidth: 781,
    maxWidth: undefined
  },
  homepageBannerMobile: {
    id: 903,
    name: 'Edge of Play',
    slot: 'homepageBanner',
    link: 'mailto:commercial@edgeofplay.com',
    image: require('../../images/adverts/eop-360x240.jpg'),
    active: true,
    width: 360,
    height: 240,
    minWidth: undefined,
    maxWidth: 780
  },
  categoryIndexOne: {
    id: 904,
    name: 'Edge of Play',
    slot: 'categoryIndexOne',
    link: 'mailto:commercial@edgeofplay.com',
    image: require('../../images/adverts/eop-220x440.jpg'),
    active: true,
    width: 220,
    height: 440,
    minWidth: 1280,
    maxWidth: undefined
  },
  categoryIndexOneMobile: {
    id: 905,
    name: 'Edge of Play',
    slot: 'categoryIndexOne',
    link: 'mailto:commercial@edgeofplay.com',
    image: require('../../images/adverts/eop-360x210.jpg'),
    active: true,
    width: 360,
    height: 210,
    minWidth: undefined,
    maxWidth: 719
  },
  categoryIndexOneTablet: {
    id: 906,
    name: 'Edge of Play',
    slot: 'categoryIndexOne',
    link: 'mailto:commercial@edgeofplay.com',
    image: require('../../images/adverts/eop-720x210.jpg'),
    active: true,
    width: 720,
    height: 210,
    minWidth: 720,
    maxWidth: 1279
  },
  categoryIndexTwo: {
    id: 907,
    name: 'Edge of Play',
    slot: 'categoryIndexTwo',
    link: 'mailto:commercial@edgeofplay.com',
    image: require('../../images/adverts/eop-220x440.jpg'),
    active: true,
    width: 220,
    height: 440,
    minWidth: 1280,
    maxWidth: undefined
  },
  categoryIndexTwoMobile: {
    id: 908,
    name: 'Edge of Play',
    slot: 'categoryIndexTwo',
    link: 'mailto:commercial@edgeofplay.com',
    image: require('../../images/adverts/eop-360x210.jpg'),
    active: true,
    width: 360,
    height: 210,
    minWidth: undefined,
    maxWidth: 719
  },
  categoryIndexTwoTablet: {
    id: 909,
    name: 'Edge of Play',
    slot: 'categoryIndexTwo',
    link: 'mailto:commercial@edgeofplay.com',
    image: require('../../images/adverts/eop-720x210.jpg'),
    active: true,
    width: 720,
    height: 210,
    minWidth: 720,
    maxWidth: 1279
  },
  videoPageOne: {
    id: 910,
    name: 'Edge of Play',
    slot: 'videoPageOne',
    link: 'mailto:commercial@edgeofplay.com',
    image: require('../../images/adverts/eop-440x260.jpg'),
    active: true,
    width: 440,
    height: 260,
    minWidth: 1366,
    maxWidth: undefined
  },
  videoPageMobileOne: {
    id: 911,
    name: 'Edge of Play',
    slot: 'videoPageMobileOne',
    link: 'mailto:commercial@edgeofplay.com',
    image: require('../../images/adverts/eop-360x240.jpg'),
    active: true,
    width: 360,
    height: 240,
    minWidth: undefined,
    maxWidth: 1365
  },
  videoPageTwo: {
    id: 912,
    name: 'Edge of Play',
    slot: 'videoPageOne',
    link: 'mailto:commercial@edgeofplay.com',
    image: require('../../images/adverts/eop-440x260.jpg'),
    active: true,
    width: 440,
    height: 260,
    minWidth: 1366,
    maxWidth: undefined
  },
  videoPageMobileTwo: {
    id: 913,
    name: 'Edge of Play',
    slot: 'videoPageMobileTwo',
    link: 'mailto:commercial@edgeofplay.com',
    image: require('../../images/adverts/eop-360x240.jpg'),
    active: true,
    width: 360,
    height: 240,
    minWidth: undefined,
    maxWidth: 1365
  }
};

export const advertSize: { [key: string]: { minW?: number; maxW?: number } } = {
  siteBanner: { minW: 781 },
  siteBannerMobile: { maxW: 780 },
  homepageBanner: { minW: 781 },
  homepageBannerMobile: { maxW: 780 },
  categoryIndexOne: { minW: 1280 },
  categoryIndexOneTablet: { minW: 720, maxW: 1279 },
  categoryIndexOneMobile: { maxW: 719 },
  categoryIndexTwo: { minW: 1280 },
  categoryIndexTwoTablet: { minW: 720, maxW: 1279 },
  categoryIndexTwoMobile: { maxW: 719 },
  videoPageOne: { minW: 1366 },
  videoPageMobileOne: { maxW: 1365 },
  videoPageTwo: { minW: 1366 },
  videoPageMobileTwo: { maxW: 1365 }
};



// WEBPACK FOOTER //
// ./src/app/repositories/utils/advertStaticData.ts